import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ReactPixel from "react-facebook-pixel";
import { GA_ID, PIXEL_ID } from "shared/constants";

import { googleExchangeCode, clearLoginError } from 'redux/users/actions';

import AuthLayout from 'components/authentication/AuthLayout';
import LoginForm from 'components/authentication/LoginForm';
import ReactGA from "react-ga";


class GoogleLoginPage extends PureComponent {
  static propTypes = {
    googleExchangeCode: PropTypes.func.isRequired,
    clearLoginError: PropTypes.func.isRequired,
    loginError: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape,
    ]),
    accessToken: PropTypes.string,
    isRegistered: PropTypes.bool,
    location: PropTypes.oneOfType([
      PropTypes.shape,
    ]),
  };

  static defaultProps = {
    loginError: null,
    accessToken: null,
    isRegistered: false,
    location: null,
  };

  extractCode = search => {
    return new URLSearchParams(search).get('code');
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.isRegistered && this.props.isRegistered) {
      ReactGA.initialize(GA_ID);
      ReactGA.event({
        category: 'New User',
        action: 'Sign Up',
        label: 'Sign Up Page Form',
      });
      const pixelOptions = {
        autoConfig: true,
        debug: false,
      };
      ReactPixel.init(PIXEL_ID, null, pixelOptions);
      ReactPixel.track('CompleteRegistration');
      // TikTok Pixel Registration event
      if (window.ttq) {
        window.ttq.track('Registration');
      }
      // Yandex Metrika
      if (window.ym) {
        window.ym(69416935, "reachGoal", "SIGNUP");
      }
    }
  }

  componentDidMount() {
    if (this.props.location) {
      const code = this.extractCode(this.props.location.search);
      this.props.googleExchangeCode(code);
    }
  }

  componentWillUnmount() {
    this.props.clearLoginError();
  }

  render() {
    return (
      <AuthLayout type="login" className="login-page__component">
        {!this.props.loginError ?
          <div>
            <Header as="h1">Log In</Header>
            <p>Please, wait...</p>
          </div>
          :
          <LoginForm />
        }
      </AuthLayout>
    );
  }
}


const mapStateToProps = state => (
  {
    accessToken: state.usersReducer.accessToken,
    refreshToken: state.usersReducer.refreshToken,
    loginError: state.usersReducer.loginError,
    isRegistered: state.usersReducer.isRegistered,
  }
);

export default connect(
  mapStateToProps,
  {
    googleExchangeCode,
    clearLoginError,
  },
)(GoogleLoginPage);
